module.exports = __webpack_public_path__ + "static/other/construction_maze.22572fbb.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/construction_maze.json
// module id = 2568
// module chunks = 0